import { FormActions } from "../../components/common/FormActions";
import {
  createViewEdit,
  formatDate,
  getForm,
  stringifyName,
} from "../../utils/helpers";
import { URL_SUPPLIER_CONFIGURABLES } from "../../utils/urls";

export const useSupplierConfigurables = () => {
  const tableColumns = () => [
    { id: "name", header: "Supplier", filter: true },
    { id: "phone_number", header: "Mobile Number", filter: true },
    { id: "email", header: "Email ", filter: true },
    { id: "contact_person_name", header: "Contact Person ", filter: true },
    { id: "actions", header: "Actions" },
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      const row = {
        ...item,
        created_at: formatDate(item.created_at),
        actions: (
          <FormActions
            actions={createViewEdit(URL_SUPPLIER_CONFIGURABLES, item?.id)}
          />
        ),
      };
      return row;
    }),
  ];

  const viewData = (item: any) => {
    return {
      supplier: item?.name,
      email: item?.email,
      phone_number: item?.phone_number,
      physical_address: item?.physical_address,
      description: item?.description,
      status: item?.status,
      created_by: stringifyName({ ...item?.created_by }),
      created_at: formatDate(item?.created_at),
    };
  };

  const formRoute = getForm(URL_SUPPLIER_CONFIGURABLES);
  return { tableColumns, tableData, formRoute, viewData };
};
